export default __webpack_public_path__ + "static/media/photo--sm--daniel-1.3c611efb.jpg";